/**
 * The guest-only paths, as their own module so the guest layout guard (`routes/layouts.tsx`) can
 * loop-guard a `?from=` target against them without importing the routes that it parents.
 */
export const GUEST_ONLY_PATHS = ['/login', '/register', '/partner-register', '/go-enterprise'];
